(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(pointer: fine)').matches) return; // desktop/mouse only, skip touch

  var colors = ['#FF6602', '#FF3EA5', '#87CEEB', '#8A9A5B', '#FFE066']; // orange, bright pink, sky blue, moss green, butter yellow
  var minDistance = 10; // px the cursor must move before spawning another mark, keeps the trail dense/continuous
  var lastX = null;
  var lastY = null;

  function spawnSprinkle(x, y) {
    var el = document.createElement('span');
    el.className = 'cursor-sprinkle';

    var size = 0.55 + Math.random() * 0.35; // rem, starts as this star size then scales down ~18% as it becomes a circle (see base.css)
    el.style.width = size + 'rem';
    el.style.height = size + 'rem';

    var fall = 14 + Math.random() * 8; // rem (~224-352px), further so the star->circle morph and fade both have room to play out
    var dx = (Math.random() - 0.5) * 16; // px, very slight sideways drift like the reference

    el.style.setProperty('--sprinkle-x', x + 'px');
    el.style.setProperty('--sprinkle-y', y + 'px');
    el.style.setProperty('--sprinkle-dx', dx + 'px');
    el.style.setProperty('--sprinkle-rotate', Math.floor(Math.random() * 30) + 'deg');
    el.style.setProperty('--sprinkle-fall', fall + 'rem');
    el.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];

    document.body.appendChild(el);
    // Three animations run on this element (move + fade + morph), so
    // animationend fires more than once; { once: true } plus the fact
    // remove() on a detached node is a no-op keeps this safe either way.
    el.addEventListener(
      'animationend',
      function () {
        el.remove();
      },
      { once: true }
    );
  }

  document.addEventListener(
    'mousemove',
    function (e) {
      if (lastX === null) {
        lastX = e.clientX;
        lastY = e.clientY;
        return;
      }
      var dx = e.clientX - lastX;
      var dy = e.clientY - lastY;
      if (Math.sqrt(dx * dx + dy * dy) < minDistance) return;
      lastX = e.clientX;
      lastY = e.clientY;
      spawnSprinkle(e.clientX, e.clientY);
    },
    { passive: true }
  );
})();